import Vue from 'vue'
import App from './App.vue'

import axios from 'axios'

import VueAxios from 'vue-axios'
import store from './store'; // 导入store

Vue.use(VueAxios, axios)
import router from "./router";

Vue.prototype.downBlob=function(data,name){
  var blob = new Blob([data], { type: 'application/octet-stream' });
  var url = window.URL.createObjectURL(blob);
  var a = document.createElement('a');
  a.href = url;
  a.download = name['content-disposition'].split("\"")[1]; // 这里可以设置下载文件的名称和扩展名
  a.style.display = 'none';
  a.click()
  setTimeout(() => {
    window.URL.revokeObjectURL(url);
  }, 100); 
}

let opsBaseURL = process.env.VUE_APP_API_URL

Vue.prototype.$axios = axios.create({
  baseURL: opsBaseURL,
  timeout: 10000,
  // withCredentials: true,
  headers: {
    post: {
      "Content-Type": "application/json",
    },
    common: {
      token:localStorage.getItem("total_token")
    },
  },
});
Vue.prototype.$axios.interceptors.response.use(
  (response) => {
    // 如果返回的状态码为200，说明接口请求成功，可以正常拿到数据
    // 否则的话抛出错误
    if (response.status === 200) {
      return Promise.resolve(response);
    }else {
      return Promise.reject(response);
    }
  },
  (error) => {
    if(error.response.status === 401){
      Vue.prototype.$axios.defaults.headers.common['Authorization'] = '';
      router.push({ path: "/login" })
    }
    if (error == "Error: Network Error") {
      return false;
    }

    return Promise.reject(error.response);
  }
)
Vue.config.productionTip = false
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';


Vue.use(ElementUI);
new Vue({
  store,
  router,
  render: h => h(App),
}).$mount('#app')
